let language = {
    CARD_SELECTION_MODE: "选卡模式：",
    RANDOMIZED_MODEL: "随机设计",
    FIXED_SET_MODEL: "固定设计",
}

export { language }